import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { MyQuotationsRowItems } from '../../models/quotations/Quotations';
import { Link } from 'react-router-dom';

export const MyQuotationsTableRow: React.FC<MyQuotationsRowItems> = (props) => {
    const { row, index } = props;
    const { t } = useTranslation('quotations', {
        keyPrefix: 'MY_QUOTATIONS',
    });
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <>
            <TableRow hover>
                <TableCell component="th" id={labelId} scope="row">
                    {row.quoteNo}
                </TableCell>
                {/*<TableCell>{row.quotationName}</TableCell>*/}
                <TableCell>{row.orderDate}</TableCell>
                <TableCell>
                    {row.status &&
                        row.status != ' ' &&
                        t(
                            'STATUS.' +
                                row.status
                                    .toString()
                                    .toUpperCase()
                                    .replace(' ', '_')
                        )}
                </TableCell>
                <TableCell align="right">
                    <Link to={'/my-quotations/' + row.quoteID}>
                        {t('TABLE_ROW.DETAILS')}
                    </Link>
                </TableCell>
            </TableRow>
        </>
    );
};
